import React from 'react'
import {connect} from 'react-redux'
import {Flex} from '/app/src/component'
import Item from './Item'
import CompanyModel from '/app/src/model/Company/model'
import {CompanySelector} from '/app/src/model/Company'

class Invoice extends React.Component {
    constructor(props){
        super(props)
        this._renderItems = this._renderItems.bind(this);
    }
    componentDidMount(){
        if(this.props.isFetching) return;
        //TODO: this fetch happens twice if we refresh on this url.
        this.props.dispatch(CompanyModel.invoiceRead());
    }
    _renderItems(invoices){
        if(!invoices.size) return;
        let ListComponents = [];
        invoices.toJS().forEach((invoice) => {
            ListComponents.push(
                <Item
                    invoice={invoice}
                    key={invoice.id}
                />
            )
        })
        return ListComponents;
    }

    render() {
        return(
            <Flex h='100%' w='100%' column>
                <Flex w='100%' borderBottom='1px solid lightgrey' py='21px'>
                    <Flex basis='20%' center>Tidsperiod</Flex>
                    <Flex basis='20%' center>Förfallodatum</Flex>
                    <Flex basis='20%' center>Att betala(SEK)</Flex>
                    <Flex basis='20%' center>Status</Flex>
                    <Flex basis='20%' center>OCR</Flex>
                </Flex>
                {this._renderItems(this.props.invoices)}
            </Flex>

        );
    }

}
function mapStateToProps(state, props){
    const invoices = CompanySelector.invoices(state)
    const isFetching = CompanySelector.invoicesIsFetching(state)
    return {invoices, isFetching}
}

export default connect(mapStateToProps)(Invoice);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/Invoice/index.js